/**
 * Created by jahidul.hasan on 10/17/2020.
 */import {EventEmitter, Injectable} from "@angular/core";
import {IPlatformToolHandler} from "@shared/components/platform-tool/platform-tool-container/platform-tool-component";
import {MagicLinkModel, TabModel} from "@shared/models/platform-tool-models";
import {Subject} from "rxjs";
import {CommandService} from "@core/services/command.service";
import {ActivatedRoute, Router} from "@angular/router";
import {DialogService} from "@shared/services/dialog-service";
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {InvalidateSubject} from "@shared/helpers/invalidate.subject";
import {PlatformCommand} from "@shared/commands/command-base";
import {take} from "rxjs/operators";
import {DialogModel} from "@shared/models/dialog.model";
import {TranslationService} from "./translation.service";
import {TranslationConfig} from "../translation-config";
import {QueryProvider} from "@shared/queries/query-provider";
import {Store} from "@ngrx/store";
import {IQueryState} from "@shared/store/reducers/query.reducer";
import {TranslationFormModel} from "../models/translation.model";
import {TranslationSources, TranslationToolNames} from "../models/translation.constants";
import {SnackBarService} from "@core/services/snack-bar.service";
import {Guid} from "guid-typescript";
@Injectable({
  providedIn: 'root',
})
export class TranslationGridHandler implements IPlatformToolHandler {
  magicLinkModelValueChanged: EventEmitter<any>;
  magicLinkModel: MagicLinkModel;
  private selectedTabModel: TabModel;
  ngUnsubscribe = new Subject<void>();
  invalidateSubject: InvalidateSubject;
  supportiveLanguageQueryKey = 'TranslationSupportiveLanguage';
  constructor(private commandService: CommandService,
              private translationService: TranslationService,
              private router: Router,
              private dialogService: DialogService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private snackBarService: SnackBarService
  ) {
  }



  executeCommand(command: PlatformCommand) {
    console.log('onPlatformTool Handler Command', command);
    switch (command.name) {
      case 'AddTranslationCommand':
        this.addTranslation(command);
        break;
      case 'ConvertCurrencyCommand':
        this.onConvertCurrency();
        break;
      case 'CompareDocumentsCommand':
        this.onCompare();
        break;
      default:
        this.executeCommandToApi(command);
        break;
    }
  }

  private executeCommandToApi(command: PlatformCommand, successMessage: string = '', errorMessage: string = '') {
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          console.log('Command Response', commandResponse);
          this.fuseSplashScreenService.hide();
          if (command.fieldValues['TranslationId']) {
            if(successMessage) {
              this.snackBarService.showInformation(successMessage);
            }
            this.invalidateSubject.invalidate();
          } else {
            this.invalidateSubject.invalidate();
          }
        },
        error => {
          //console.error('Failed ToolBarComponent command', error);
          this.fuseSplashScreenService.hide();
          if(errorMessage) {
            this.snackBarService.showError(errorMessage);
          }
        });
    }
  }

  valueChanged($event) {
    console.log('Inside Handler', $event);
    if (this.handleAction($event)) {
      return;
    }
    if (this.handleCommand($event)) {
      return;
    }
    if ($event.item && $event.fieldDefinition && $event.fieldSection) {
      if ($event.fieldSection.id === 'translation' || $event.fieldSection.id === 'kpmgtranslation') {
        switch ($event.fieldDefinition.key) {
          case 'FileName':
            this.navigateToTranslationView($event.item.id);
            return;
        }
      }
    }
  }
  private handleCommand($event): boolean {
    if ($event.command) {
/*      switch ($event.command.name) {
        default:
          this.executeCommand($event.command);
          return true;
      }*/
    }
    return false;
  }

  private handleAction($event): boolean {
    if (this.selectedTabModel && $event.action) {
      switch ($event.action.id) {
        case 'View':
          console.log('tran view:',$event);
          this.navigateToTranslationView($event.item.id);
          return true;
        case 'Delete':
          console.log('tran delete:',$event);
          this.deleteTranslation($event.item.id);
          return true;
      }
    }
    return false;
  }

  setSelectedTab(selectedTab: TabModel): void {
    this.selectedTabModel = selectedTab;
  }

  destroy() {
    this.invalidateSubject.close();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  onCompare() {
    let translationId = Guid.create().toString();
    const dialogModel: DialogModel = DialogModel.create(
      'Compare Options',
      'TranslationCompareDialogComponent',
      {translationId: translationId},
      '900px',
      '900px'
    );
    dialogModel.okCaption = 'Compare';
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      console.log(res);
      if (res.action === 'ok') {
        const formConfig = res.data.input.formConfig;
        const form1 = formConfig.form1;
        const form2 = formConfig.form2;
        let fileOne = new TranslationFormModel();
        fileOne.id = form1.fileId;
        fileOne.language = form1.language;
        fileOne.isScanned = form1.isFileScanned;
        fileOne.fileName = form1.fileName;
        let fileTwo = new TranslationFormModel();
        fileTwo.id = form2.fileId;
        fileTwo.language = form2.language;
        fileTwo.isScanned = form2.isFileScanned;
        fileTwo.fileName = form2.fileName;
        this.translationService.addTranslation(TranslationConfig.getTranslationApiName(), fileOne, fileTwo, TranslationToolNames.Compare, '', translationId, TranslationSources.TranslationGrid, [], formConfig.storageSettings);
      }
    });
  }

  onConvertCurrency() {
    let translationId = Guid.create().toString();
    const dialogModel: DialogModel = DialogModel.create(
      'Convert Currency Options',
      'TranslationConvertCurrencyDialogComponent',
      {translationId: translationId},
      '600px',
      '700px'
    );
    dialogModel.okCaption = 'Convert';
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      console.log(res);
      if (res.action === 'ok') {
        const formConfig = res.data.input.formConfig;
        let fileOne = new TranslationFormModel();
        fileOne.id = formConfig.fileId;
        fileOne.language = formConfig.toLanguage;
        fileOne.isScanned = formConfig.isFileScanned;
        fileOne.fileName = formConfig.fileName;
        fileOne.isClientFile = true;
        let fileTwo = new TranslationFormModel();
        this.translationService.addTranslation(TranslationConfig.getTranslationApiName(), fileOne, fileTwo, TranslationToolNames.ConvertCurrency, '', translationId, TranslationSources.TranslationGrid, [], formConfig.storageSettings);
      }
    });
  }

  private addTranslation(command: PlatformCommand) {
    let translationId = Guid.create().toString();
    const dialogModel: DialogModel = DialogModel.create(
      'Translate Document',
      'TranslationSettingComponent',{translationId: translationId},
      '600px',
      '700px'
    );
    dialogModel.okCaption = 'Translate';
    this.dialogService.showOkCancelDialog(dialogModel).subscribe( res => {
      console.log(res);
      if (res && res.action === 'OK') {
        const formConfig = res.data.input.formConfig;
        let fileOne = new TranslationFormModel();
        fileOne.id = formConfig.fileId;
        fileOne.language = formConfig.fromLanguage;
        fileOne.isScanned = formConfig.isFileScanned;
        fileOne.fileName = formConfig.fileName;
        fileOne.isClientFile = true;
        let fileTwo = new TranslationFormModel();
        fileTwo.language = formConfig.toLanguage;
        this.translationService.addTranslation(TranslationConfig.getTranslationApiName(), fileOne, fileTwo, TranslationToolNames.Translation, '', translationId, TranslationSources.TranslationGrid, [], formConfig.storageSettings);
      }
    });
  }

  private navigateToTranslationView(id: any) {
    this.router.navigateByUrl(`translation/${id}`);
  }

  private deleteTranslation(translationId: string) {
    let command = new PlatformCommand('DeleteTranslationCommand', TranslationConfig.getTranslationApiName());
    command.fieldValues['TranslationId'] = translationId;
    this.executeCommandToApi(command, 'Deleted Successfully!!!', 'Delete failed!!');
  }
}


